import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { useRef } from "react";

/**
 * Hover-tilt wrapper that follows cursor position with subtle 3D rotation.
 * Use for high-emphasis cards (CTA tiles, featured stats, etc).
 */
export default function TiltCard({ children, intensity = 8, className = "", ...rest }) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const springConfig = { stiffness: 150, damping: 18, mass: 0.5 };
  const rotateX = useSpring(useTransform(y, [-50, 50], [intensity, -intensity]), springConfig);
  const rotateY = useSpring(useTransform(x, [-50, 50], [-intensity, intensity]), springConfig);

  const onMouseMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const px = e.clientX - rect.left - rect.width / 2;
    const py = e.clientY - rect.top - rect.height / 2;
    x.set((px / rect.width) * 100);
    y.set((py / rect.height) * 100);
  };
  const reset = () => { x.set(0); y.set(0); };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMouseMove}
      onMouseLeave={reset}
      style={{ rotateX, rotateY, transformStyle: "preserve-3d", perspective: 1000 }}
      className={`will-change-transform ${className}`}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
